import styled from "styled-components";

import { colorsPalettes, rgba, setElevation, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow, IconButton } from "@similarweb/ui-components";

const { carbon, sky } = colorsPalettes;

export const Container = styled(FlexColumn)`
    position: relative;
    padding: 16px;
    align-items: center;
    flex-shrink: 0;
    background: ${carbon[0]};
    ${setElevation("Z1")}
    gap: 24px;
    border-radius: 6px;
`;

export const HookContainer = styled(FlexColumn)`
    position: relative;
    align-items: center;
    justify-content: center;
    align-self: stretch;
    padding: 24px 0;
    gap: 20px;
    background: ${sky[100]};
    border-radius: 8px;
`;

export const Illustration = styled.img`
    width: 425px;
    max-width: 100%;
    border-radius: 8px;
    box-shadow: 0 12px 34px 0 ${rgba(sky[400], 0.5)};
`;

export const Title = styled.div<{ $wincher?: boolean }>`
    text-align: center;
    ${({ $wincher }) => setFontVariant($wincher ? "boldH3" : "h3", carbon[500])};
`;

export const Message = styled(FlexColumn)`
    align-items: center;
    max-width: 425px;
`;

export const Body = styled(FlexColumn)`
    align-items: center;
    gap: 16px;
`;

export const Line = styled(FlexRow)<{ $wincher?: boolean }>`
    text-align: center;
    ${({ $wincher }) => setFontVariant($wincher ? "captionTitle" : "body1", carbon[400])};
`;

export const MessageBold = styled.span`
    ${setFontVariant("subtitle1", carbon[400])};
`;

export const Footer = styled(FlexRow)`
    align-items: center;
    justify-content: center;
`;

export const CloseButton = styled(IconButton)`
    position: absolute;
    top: 8px;
    right: 8px;
`;
